function getCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  if (match) {
    try {
      return JSON.parse(decodeURIComponent(match[2]));
    } catch (e) {
      console.error('Error parsing cookie:', e);
      return [];
    }
  }
  return [];
}

function setCookie(name, value, days) {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + encodeURIComponent(JSON.stringify(value)) + expires + "; path=/";
}

function renderRecentlyViewedProducts() {
  const viewedProducts = getLocalStorage('recentlyViewedProducts');
  const swiperWrapper = document.querySelector('.product-slider__wrapper');
  
  if (viewedProducts && viewedProducts.length > 0 && swiperWrapper) {
    swiperWrapper.innerHTML = '';
    
    viewedProducts.forEach(product => {
      if (product.show) {
        console.log("prodColor", product.prodColor);
          let prodColor = '';
  
          if (typeof product.prodColor !== 'undefined') {
              try {
                  prodColor = JSON.parse(product.prodColor);
                  console.log("Parsed prodColor:", prodColor);
              } catch (error) {
                  console.error('Error parsing product-option:', error);
              }
          }
  
          let colorOptionsHTML = '';
          prodColor.forEach((colorOption, index) => {
            const colorValue = colorOption[`colorvalue${index + 1}`];
            const variantID = colorOption[`colorVariant${index + 1}`];
            const colorImage = colorOption[`colorImage${index + 1}`];
          
            colorOptionsHTML += `
              <span class="card__variant-options-value" style="background-color:${colorValue}" 
                data-variant-id="${variantID}" 
                data-attach-variant-image="${colorImage}"
                data-custom-option-value>
                <span class="visually-hidden">${colorValue}</span>
              </span>
            `;
          });
          console.log(colorOptionsHTML)
  
          let priceHTML = '';
          if (product.compare_at_price) {
              priceHTML = `
                  <div class="custom-price p-xs">
                    <span class="original-price">${product.compare_at_price}</span>
                    <span class="discounted-price color-black">${product.price}</span>
                  </div>
              `;
          } else {
              priceHTML = `
                  <div class="custom-price p-xs color-black">${product.price}</div>
              `;
          }
  
          const slideHTML = `
            <li class="product-slider__slide grid__item prod-card">
              <div class="prod-card__wrapper">
                <a class="full-unstyled-link" href="${product.url}">
                  <img class="prod-card__img" src="${product.featured_image}" alt="${product.title}">
                </a>
                  <div class="prod-card__info">   
                    <div class="card__variant-options" data-custom-options="">
                      ${colorOptionsHTML}
                    </div>
                    <a class="full-unstyled-link" href="${product.url}">
                      <h3 class="prod-card__heading h5">${product.title}</h3>
                      ${priceHTML}
                    </a>
                  </div>
              </div>
            </li>
          `;
  
          swiperWrapper.insertAdjacentHTML('beforeend', slideHTML);
      }
  });
    const get_swatches =  document.querySelectorAll("[data-custom-option-value]");
    console.log("get_swatches", get_swatches);
    get_swatches.forEach((item)=>{
      item.addEventListener("click", function(event) {
        const parentLi = event.target.closest("li");
          if (parentLi) {
              console.log("Parent <li> element:", parentLi);
              const get_img = parentLi.querySelector(".prod-card__wrapper .prod-card__img");
              console.log("image: ", get_img);
              get_img.src = item.getAttribute("data-attach-variant-image");
          } else {
              console.error("No parent <li> found!");
          }
      });
    })
  
  } else {
    const recentProdContainer = document.querySelector('[data-recent="container"]');
    recentProdContainer.style.display = 'none';
  }
}

document.addEventListener('DOMContentLoaded', function() {
  renderRecentlyViewedProducts();
});